import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig, withInMemoryScrolling } from '@angular/router';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

import { AppModule } from './app/app.module';
import { AppComponent } from './app/app.component';
import { routes, routerOptions } from './app/app-routing.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if(window){
    window.console.log=function(){};
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom(AppModule),
    provideAnimations(),
    // CDK 22 hosts overlays in a popover by default, which paints them in the
    // browser's top layer above any z-index. The modal shim stacks on the
    // app's own 1040/1050/9999 layers, so tooltips and dialogs opt back out.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: routerOptions.onSameUrlNavigation,
        paramsInheritanceStrategy: routerOptions.paramsInheritanceStrategy
      }),
      withInMemoryScrolling({ 
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      })
    )
  ]
}).catch(err => console.error(err));
